<template>
    <btn 
        component-name="btn-secondary"
        class="inline-flex justify-center items-center gap-sm h-[66px] px-2xl border border-skin-inverted text-button-small text-skin-base bg-transparent hover:text-skin-inverted hover:bg-skin-inverted transition-colors duration-200 ease-in-out whitespace-nowrap"
    >
        <template v-slot:default="slotProps">
            <span class="whitespace-nowrap first-letter:uppercase">{{ slotProps.title }}</span>
            <vector-icon v-if="slotProps.icon" :icon="slotProps.icon" size="small" />
        </template>
    </btn>
</template>